import React from 'react';

export class Tooltip extends React.PureComponent {
  getReactContainerClasses() {
    return ['Tooltip'];
  }

  render() {
    const { value } = this.props;

    if (!value) {
      return null;
    }

    return (
      <div
        className="Tooltip"
        style={{ backgroundColor: this.props.color || 'white' }}
      >
        <p>
          <span>{value}</span>
        </p>
      </div>
    );
  }
}
